/* Svensk katalog for locale-advisor-plan-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'adv.plan.viewForecast': 'Visa prognos',
  'adv.plan.forecastTitle': 'Kassaflöde med planerade händelser',
  'adv.plan.forecastIntro': 'Jämför saldot baserat på bokförda siffror med saldot efter de händelser du har registrerat.',
  'adv.plan.forecastWithoutEvents': 'Utan planerade händelser',
  'adv.plan.forecastWithEvents': 'Med planerade händelser',
  'adv.plan.forecastChange': 'Förändring vid årets slut',
  'adv.plan.forecastScope': 'Planerade händelser ändrar bara prognosen, inte bokföringen eller budgeten. Saldot stannar vid noll i kurvan, så förändringen vid årets slut kan vara mindre än summan av händelserna.',
  'adv.plan.showVariance': 'Visa avvikelser',
  'adv.plan.hideVariance': 'Dölj avvikelser',
});
